import { render, staticRenderFns } from "./ArticlesIndex.vue?vue&type=template&id=04491f3a&"
import script from "./ArticlesIndex.vue?vue&type=script&lang=js&"
export * from "./ArticlesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports